/**
 * Type-encapsulates the base navigation context with case-specific functionality.
 *
 * Actual logical encapsulation happens in `useCaseSidebarNavigator`.
 *
 * This is used to provide the navigation context to the case sidebar components.
 */

import type { CaseNavigationContext } from '@/modules/Cases/Sidebar/useCaseSidebarNavigator'

import {
  navigationContextToken,
  useNavigationContext,
} from '@/modules/Project/Navigation/navigationContext'

import { provide } from 'vue'

export const useCaseNavigationContext = useNavigationContext<CaseNavigationContext>

export const provideCaseSidebarNavigationContext = (ctx: CaseNavigationContext) =>
  provide(navigationContextToken, ctx)
